/* eslint-disable class-methods-use-this */
import sa from 'sa-sdk-javascript';
import EVENTS from './events.js';
import { getParameterByName } from '../utils/util';

window.SAEVENTS = EVENTS;
const EVENT_VALUES = [];
Object.keys(EVENTS).forEach((k) => {
  EVENT_VALUES.push(EVENTS[k]);
});

const SA_SERVER_URL = process.env.SENSOR_URL; // 默认走测试
const isProduction = process.env.ENVIRONMENT === 'production';
class JsSensor {
  constructor(options = {}) {
    let showLog = isProduction ? false : !!options.debug;
    // URL参数sensor_debug为true即可进入debug模式，方便线上调试
    if (getParameterByName('sensor_debug') === 'true') {
      showLog = true;
    }
    sa.init({
      server_url: options.server_url || SA_SERVER_URL,
      show_log: showLog,
      debug_mode: isProduction ? false : !!options.debug_mode,
      is_single_page: options.is_single_page || false,
    });

    this.initUser(options.user);

    sa.registerPage({
      platform: 'web', // 标识是web平台,以区别android和ios
      site: 'martin', // 标识web站点
    });
    // 自动收集$pageview事件
    sa.quick('autoTrack');
  }
  initUser(user) {
    // init the user
    if (user) {
      this.login(user.id);
    } else {
      this.logout();
    }
  }
  login(userId) {
    // sensors目前仅支持一个userId
    sa.login(userId);
  }
  /*
   * 取消当前 login 的 id，改成最初自动生成的 cookie_id，A -> 真A -> A
   * 如果设置isNew 为true，则会重新生成一个新的 cookie_id，A -> 真A -> B
   */
  logout(isNew) {
    sa.logout(isNew);
  }
  // 设置pagename
  setPageName(pagename) {
    sa.registerPage({
      pagename,
    });
  }
  sendPV(cp) {
    sa.quick('autoTrack', cp);
  }
  trackEvent(eventId, cp, callback) {
    if (EVENT_VALUES.indexOf(eventId) >= 0) {
      sa.track(eventId, cp, callback);
    } else if (!isProduction && window.console) {
      console.warn('when you see this warning, the track data is failure, because %s is not listed in events.js', eventId); // eslint-disable-line no-console
    }
  }
}

export default JsSensor;



// WEBPACK FOOTER //
// ./src/sensorsdata/index.js